import Repository from "./Repository";

const CREATE_BOOKING = "/createbooking";
const GET_BOOKING = "/getbooking";
const GET_ALL_BOOKING = "/getallbooking";
const GET_VOLUNTEER_BOOKING = "/getbookingbyvolunteerid";
const DELETE_BOOKING = "/deletebooking";
const EDIT_BOOKING = "/editbooking";
const GET_UPCOMING_BOOKING = "/getbookingbyupcomingstatus";
const GET_COMPLETED_BOOKING = "/getbookingbycompletedstatus";
const CREATE_REQUIREMENT = "/createrequirement";
const GET_REQUIREMENT = "/getrequirement";
const GET_ALL_REQUIREMENT = "/getallrequirement";
const DELETE_REQUIREMENT = "/deleterequirement";
const EDIT_REQUIREMENT = "/editrequirement";
const CREATE_REVIEW = "/createreview";
const GET_REVIEW = "/getreview";
const GET_ALL_REVIEW = "/getallreview";
const DELETE_REVIEW = "/deletereview";
const EDIT_REVIEW = "/editreview";
const CREATE_VOLUNTEER = "/createvolunteer";
const ADD_ADMIN_VOLUNTEER = "/addVolunteer";
const UPDATE_STATUS_VOLUNTEER = "/updateStatusvolunteer";
const GET_VOLUNTEER_BY_LOCATION = "/getVolunteerByLocation";
const GET_VOLUNTEER_BY_SERVICE = "/getVolunteerByService";
const GET_VOLUNTEER_BY_DESIGNATION = "/getVolunteerByDesignation";
const GET_VOLUNTEER_BY_ID = "/getVolunteerById";
const GET_ALL_VOLUNTEER = "/getallvolunteer";
const GET_Volunteer_BY_ADMIN = "/getvolunteerbyadmin";
const GET_All_Count = "/getallcounts";
const DELETE_VOLUNTEER = "/deletevolunteer";
const PAUSE_VOLUNTEER = "/pausevolunteer";
const EDIT_VOLUNTEER = "/editvolunteer";
const GET_VOLUNTEER_BY_USERID = "/getVolunteerByUserId";
const GET_ALL_BOOKING_COUNTS = "/getallbookingcounts";
const EMAIL_BOOKING_SESSION = "/send";
const EMAIL_ACCEPT_VOLUNTEER = "/accept";
const EMAIL_REJECT_VOLUNTEER = "/reject";
const EMAIL_POST_REQ = "/emailpostreq";
const EMAIL_BECOME_VOL = "/emailbecomevol";
const EMAIL_BOOKING = "/emailbooking";
const ADD_LOCATION = "/addlocation";
const GET_ALL_LOCATION = "/getalllocation";
const GET_LOCATION_BY_NAME = "/getlocationbyname";
const DELETE_LOCATION = "/deletelocation";
const EDIT_LOCATION = "/editlocation";
const GET_ALL_LOCATION_NAME = "/getalllocationname";
const CREATE_WITHDRAWAL = "/createWithdrawal";
const GET_WITHDRAWAL = "/getWithdrawal";
const GET_ALL_WITHDRAWAL = "/getAllWithdrawal";
const DELETE_WITHDRAWAL = "/deleteWithdrawal";
const EDIT_WITHDRAWAL = "/editWithdrawal";

export default {
  createbooking(payload) {
    return Repository.post(transformRoutebooking(CREATE_BOOKING), payload);
  },
  getbooking(payload) {
    return Repository.post(transformRoutebooking(GET_BOOKING), payload);
  },
  getvolunteerbooking(payload) {
    return Repository.post(
      transformRoutebooking(GET_VOLUNTEER_BOOKING),
      payload
    );
  },
  get_allbooking(payload) {
    return Repository.post(transformRoutebooking(GET_ALL_BOOKING), payload);
  },
  get_upcomingbooking(payload) {
    return Repository.post(
      transformRoutebooking(GET_UPCOMING_BOOKING),
      payload
    );
  },
  get_completedbooking(payload) {
    return Repository.post(
      transformRoutebooking(GET_COMPLETED_BOOKING),
      payload
    );
  },
  get_allbookingcounts(payload) {
    return Repository.post(
      transformRoutebooking(GET_ALL_BOOKING_COUNTS),
      payload
    );
  },
  deletebooking(payload) {
    return Repository.post(transformRoutebooking(DELETE_BOOKING), payload);
  },
  editbooking(payload) {
    return Repository.post(transformRoutebooking(EDIT_BOOKING), payload);
  },
  createrequirement(payload) {
    return Repository.post(
      transformRouterequirement(CREATE_REQUIREMENT),
      payload
    );
  },
  getrequirement(payload) {
    return Repository.get(transformRouterequirement(GET_REQUIREMENT), payload);
  },
  get_allrequirement(payload) {
    return Repository.get(
      transformRouterequirement(GET_ALL_REQUIREMENT),
      payload
    );
  },
  deleterequirement(payload) {
    return Repository.post(
      transformRouterequirement(DELETE_REQUIREMENT),
      payload
    );
  },
  editrequirement(payload) {
    return Repository.post(
      transformRouterequirement(EDIT_REQUIREMENT),
      payload
    );
  },
  createreview(payload) {
    return Repository.post(transformRoutereview(CREATE_REVIEW), payload);
  },
  getreview(payload) {
    return Repository.get(transformRoutereview(GET_REVIEW), payload);
  },
  get_allreview(payload) {
    return Repository.post(transformRoutereview(GET_ALL_REVIEW), payload);
  },
  deletereview(payload) {
    return Repository.post(transformRoutereview(DELETE_REVIEW), payload);
  },
  editreview(payload) {
    return Repository.post(transformRoutereview(EDIT_REVIEW), payload);
  },
  createvolunteer(payload) {
    return Repository.post(transformRoutevolunteer(CREATE_VOLUNTEER), payload);
  },

  addAdminVolunteer(payload) {
    return Repository.post(
      transformRoutevolunteer(ADD_ADMIN_VOLUNTEER),
      payload
    );
  },

  update_status_volunteer(payload) {
    return Repository.post(
      transformRoutevolunteer(UPDATE_STATUS_VOLUNTEER),
      payload
    );
  },
  get_volunteerbylocation(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_VOLUNTEER_BY_LOCATION),
      payload
    );
  },

  getVolunteerByService(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_VOLUNTEER_BY_SERVICE),
      payload
    );
  },
  getVolunteerByDesignation(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_VOLUNTEER_BY_DESIGNATION),
      payload
    );
  },
  get_volunteerbyid(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_VOLUNTEER_BY_ID),
      payload
    );
  },
  get_all_volunteer(payload) {
    return Repository.get(transformRoutevolunteer(GET_ALL_VOLUNTEER), payload);
  },
  get_volunteer_by_admin(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_Volunteer_BY_ADMIN),
      payload
    );
  },
  // get_volunteer_by_admin(payload) {
  //   return Repository.post(
  //     transformRoutevolunteer(GET_Volunteer_BY_ADMIN),
  //     payload
  //   );
  // },
  get_all_count(payload) {
    return Repository.post(transformRoutevolunteer(GET_All_Count), payload);
  },
  deletevolunteer(payload) {
    return Repository.post(transformRoutevolunteer(DELETE_VOLUNTEER), payload);
  },
  pausevolunteer(payload) {
    return Repository.post(transformRoutevolunteer(PAUSE_VOLUNTEER), payload);
  },
  editvolunteer(payload) {
    return Repository.post(transformRoutevolunteer(EDIT_VOLUNTEER), payload);
  },
  get_volunteerbyuserid(payload) {
    return Repository.post(
      transformRoutevolunteer(GET_VOLUNTEER_BY_USERID),
      payload
    );
  },

  email_bookingsession(payload) {
    return Repository.post(transformRouteemail(EMAIL_BOOKING_SESSION), payload);
  },
  email_acceptvolunteer(payload) {
    return Repository.post(
      transformRouteemail(EMAIL_ACCEPT_VOLUNTEER),
      payload
    );
  },
  email_rejectvolunteer(payload) {
    return Repository.post(
      transformRouteemail(EMAIL_REJECT_VOLUNTEER),
      payload
    );
  },
  email_postreq(payload) {
    return Repository.post(transformRouteemail(EMAIL_POST_REQ), payload);
  },
  email_becomevol(payload) {
    return Repository.post(transformRouteemail(EMAIL_BECOME_VOL), payload);
  },
  email_booking(payload) {
    return Repository.post(transformRouteemail(EMAIL_BOOKING), payload);
  },
  add_location(payload) {
    return Repository.post(transformRouteLocation(ADD_LOCATION), payload);
  },
  get_all_location(payload) {
    return Repository.post(transformRouteLocation(GET_ALL_LOCATION), payload);
  },
  get_all_location_name(payload) {
    return Repository.post(
      transformRouteLocation(GET_ALL_LOCATION_NAME),
      payload
    );
  },
  get_location_by_name(payload) {
    return Repository.post(
      transformRouteLocation(GET_LOCATION_BY_NAME),
      payload
    );
  },
  delete_location(payload) {
    return Repository.post(transformRouteLocation(DELETE_LOCATION), payload);
  },
  edit_location(payload) {
    return Repository.post(transformRouteLocation(EDIT_LOCATION), payload);
  },

  createWithdrawal(payload) {
    return Repository.post(
      transformRouteWithdrawal(CREATE_WITHDRAWAL),
      payload
    );
  },
  getWithdrawal(payload) {
    return Repository.get(transformRouteWithdrawal(GET_WITHDRAWAL), payload);
  },
  getAllWithdrawal(payload) {
    return Repository.post(
      transformRouteWithdrawal(GET_ALL_WITHDRAWAL),
      payload
    );
  },
  deleteWithdrawal(payload) {
    return Repository.post(
      transformRouteWithdrawal(DELETE_WITHDRAWAL),
      payload
    );
  },
  editWithdrawal(payload) {
    return Repository.post(transformRouteWithdrawal(EDIT_WITHDRAWAL), payload);
  },
};

const transformRoutebooking = (route) => {
  return `/respitecare/booking${route}`;
};

const transformRouterequirement = (route) => {
  return `/respitecare/requirement${route}`;
};

const transformRoutereview = (route) => {
  return `/respitecare/review${route}`;
};

const transformRoutevolunteer = (route) => {
  return `/respitecare/volunteer${route}`;
};

const transformRouteemail = (route) => {
  return `/respitecare/email${route}`;
};

const transformRouteLocation = (route) => {
  return `/respitecare/location${route}`;
};

const transformRouteWithdrawal = (route) => {
  return `/respitecare/withdrawal${route}`;
};
